import React from 'react';
import { bool, func, string, shape } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { Modal, InlineTextButton } from '../../components';
import { supportedLanguages } from '../../util/translations';
import classNames from 'classnames';

import css from './LanguageModal.module.css';

// LanguageOption Component
const LanguageOption = ({ language, isSelected, onSelectLanguage }) => {
  const languageClasses = classNames(css.language, {
    [css.selectedLanguage]: isSelected,
  });

  return (
    <InlineTextButton
      className={languageClasses}
      onClick={() => onSelectLanguage(language.code)}
      type="button"
    >
      <div className={css.languageText}>{language.language}</div>
      <div className={css.languageCountry}>{language.country}</div>
    </InlineTextButton>
  );
};

LanguageOption.propTypes = {
  language: shape({
    code: string.isRequired,
    language: string.isRequired,
    country: string.isRequired,
  }).isRequired,
  isSelected: bool.isRequired,
  onSelectLanguage: func.isRequired,
};

// LanguageSelector Component
const LanguageSelector = ({ selectedLanguageId, onSelectLanguage }) => (
  <div className={css.languages}>
    {supportedLanguages.map(language => (
      <LanguageOption
        key={language.code}
        language={language}
        isSelected={language.code === selectedLanguageId}
        onSelectLanguage={onSelectLanguage}
      />
    ))}
  </div>
);

LanguageSelector.propTypes = {
  selectedLanguageId: string.isRequired,
  onSelectLanguage: func.isRequired,
};

// LanguageModal Component
const LanguageModal = ({
  className,
  rootClassName,
  id,
  isOpen,
  onCloseModal,
  onManageDisableScrolling,
  onChangeLanguage,
  intl,
}) => {
  const selectedLanguageId = intl.locale;

  const handleSelectLanguage = locale => {
    if (locale !== intl.locale) {
      onChangeLanguage(locale);
    }
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="LanguageModal.title" />
      </p>
      <LanguageSelector
        selectedLanguageId={selectedLanguageId}
        onSelectLanguage={handleSelectLanguage}
      />
    </Modal>
  );
};

LanguageModal.defaultProps = {
  className: null,
  rootClassName: null,
};

LanguageModal.propTypes = {
  className: string,
  rootClassName: string,
  id: string.isRequired,
  isOpen: bool.isRequired,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onChangeLanguage: func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(LanguageModal);
